export type HrArea = 'overview' | 'people' | 'changes' | 'letters' | 'cases' | 'setup';

/** Where each tab of the old eight-tab page lives now. Sent notifications still link to them. */
const LEGACY_TABS: Record<string, Record<string, string>> = {
  directory: { tab: 'people' },
  'org-chart': { tab: 'people', view: 'chart' },
  movements: { tab: 'changes' },
  probation: { tab: 'changes', view: 'probation' },
  documents: { tab: 'letters' },
  policies: { tab: 'letters', view: 'policies' },
  structure: { tab: 'setup' },
};

/** The search string to redirect to when a URL uses old parameters, otherwise null. */
export function upgradeLegacyHrParams(params: URLSearchParams): string | null {
  const legacyTab = LEGACY_TABS[params.get('tab') ?? ''];
  const legacyCompany = params.get('company');
  const legacyEmployee = params.get('employee') && legacyCompany;
  if (!legacyTab && !legacyCompany) return null;
  const next = new URLSearchParams(params);
  if (legacyTab) {
    for (const [key, value] of Object.entries(legacyTab)) next.set(key, value);
  }
  if (legacyCompany) {
    next.delete('company');
    next.set('companyId', legacyCompany);
    if (legacyEmployee) next.set('employeeCompany', legacyCompany);
  }
  return `?${next.toString()}`;
}

/** Plain names for employment statuses. */
export const PERSON_STATUS_LABELS: Record<string, string> = {
  not_set_up: 'Not set up',
  preboarding: 'Starting soon',
  onboarding: 'Onboarding',
  probation: 'On probation',
  active: 'Active',
  on_leave: 'On leave',
  suspended: 'Suspended',
  notice: 'On notice',
  exited: 'Left',
  archived: 'Archived',
};
